import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {IProdGridService} from 'prod-grid';
import {HttpExtraParams, HttpFilterParam} from 'prod-shared';
import {HttpClient} from "@angular/common/http";
import {OrganizationTreeSelect} from "../dip/organization-tree-select";
import {OrganizationUserGroup} from "../models/organization-user-group";

@Injectable({
  providedIn: 'root'
})
export class OrganizationUserGroupService implements IProdGridService {
  constructor(private httpClient: HttpClient, private organizationTreeSelect: OrganizationTreeSelect) {
  }

  getProdGridData(params?: HttpExtraParams): Observable<Object> {
    return this.httpClient.get<{ data: { result: OrganizationUserGroup[], totalCount: number }, success: boolean }>(`/api/organizationUserGroups`, {params});
  }

  prodGridAdd(values: any): Observable<Object> {
    return this.httpClient.post(`/api/organizationUserGroup`, values);
  }

  prodGridPatch(values: any, id: number): Observable<Object> {
    return this.httpClient.patch(`/api/organizationUserGroup/${id}`, values);
  }

  prodGridRemove(id: number): Observable<Object> {
    return this.httpClient.delete(`/api/organizationUserGroup/${id}`);
  }

  getOrganizationFilter(): HttpFilterParam[] {
    let ids = [];
    ids = ids.concat(this.organizationTreeSelect.ids);
    if (this.organizationTreeSelect.company) ids.push(this.organizationTreeSelect.company.id);
    return [new HttpFilterParam({
      property: 'organization',
      operator: 'in',
      value: ids
    })];
  }
}
